import * as roomsKey from '../../../packages/accommodation/roomsKey.js'

export const parse = function (string) {
  if (string) {
    var re = /(\d+)x(.*?)x(.*)/
    var match = re.exec(string)

    var nights = Number(match[1])
    if (nights > 0)
      var extraNightRooms = {
        nights: nights,
        hotelId: match[2],
        rooms: roomsKey.parse(match[3]),
      }
    return extraNightRooms
  }
  return undefined
}

export const stringify = function (extraStay) {
  if (
    extraStay &&
    extraStay.hotelId &&
    extraStay.nights > 0 &&
    extraStay.rooms
  ) {
    return (
      extraStay.nights +
      'x' +
      extraStay.hotelId +
      'x' +
      roomsKey.stringify(extraStay.rooms)
    )
  }
  return undefined
}
